
export class ProjectDataNavisionSegmentInfo {
	public id: number = 0;
	public valla: string = '';
	public ml: string = '';
}